/* eslint-disable node/no-unsupported-features/es-syntax */
import { ISSUES_ROUTE_NAMES } from "@/shared";

export const ISSUES_ROUTES = [
    {
        name: ISSUES_ROUTE_NAMES.LIST,
        path: "/issues",
        meta: {
            title: "Проблемы клиентов",
        },
        component: () => import("../ui/IssuesPage.vue"),
    },
];
